var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLuggage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.417 6.50002H16.2503V3.25002C16.2503 2.65419 15.7628 2.16669 15.167 2.16669H10.8337C10.2378 2.16669 9.75033 2.65419 9.75033 3.25002V6.50002H7.58366C6.39199 6.50002 5.41699 7.47502 5.41699 8.66669V20.5834C5.41699 21.775 6.39199 22.75 7.58366 22.75C7.58366 23.3459 8.07116 23.8334 8.66699 23.8334C9.26283 23.8334 9.75033 23.3459 9.75033 22.75H16.2503C16.2503 23.3459 16.7378 23.8334 17.3337 23.8334C17.9295 23.8334 18.417 23.3459 18.417 22.75C19.6087 22.75 20.5837 21.775 20.5837 20.5834V8.66669C20.5837 7.47502 19.6087 6.50002 18.417 6.50002ZM10.292 19.5H8.66699V9.75002H10.292V19.5ZM13.8128 19.5H12.1878V9.75002H13.8128V19.5ZM14.6253 6.50002H11.3753V3.79169H14.6253V6.50002ZM17.3337 19.5H15.7087V9.75002H17.3337V19.5Z",
    fill: "#979797"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggage);
export default __webpack_public_path__ + "static/media/luggage.8d0165dc3cd80d56b22ea1259dd5460e.svg";
export { ForwardRef as ReactComponent };